import { Box, useMediaQuery } from '@mui/material'
import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useGetUserQuery } from 'state/api';

const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)")   // Boolean Value
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const userId = useSelector((state) => state.global.userId);
  const {data} = useGetUserQuery(userId);
  return (
    <Box display={isNonMobile ? 'flex': 'block'} width="100%" height="100%">
      <Sidebar isNonMobile={isNonMobile} drawerWidth='250px' isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} user={data || {}}/>
        <Box flexGrow={1}>
            <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} user={data || {}}/>
            <Outlet/>
        </Box>

    </Box>
  )
}

export default Layout
